/* Back 9 Pro theme scripts */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* Header: shadow on scroll + mobile menu ------------------------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const toggle = $('[data-menu-toggle]', header);
    const panel = $('#MobileNav');
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
        document.body.style.overflow = open ? '' : 'hidden';
      });
    }
  }

  /* Reveal on scroll ----------------------------------------------------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* Dialog helpers ------------------------------------------------------- */
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }
  $$('dialog').forEach((d) => {
    d.addEventListener('close', () => {
      document.body.style.overflow = '';
      if (d.dataset.process && location.hash === '#' + d.dataset.process) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    });
    // Close when clicking the backdrop
    d.addEventListener('click', (e) => { if (e.target === d) closeDialog(d); });
    $$('[data-close]', d).forEach((b) => b.addEventListener('click', () => closeDialog(d)));
  });

  /* Decoration process modals ------------------------------------------- */
  function openProcess(id) {
    const dialog = document.querySelector('dialog[data-process="' + CSS.escape(id) + '"]');
    if (!dialog) return false;
    openDialog(dialog);
    const scroller = $('.process-modal__scroll', dialog);
    if (scroller) scroller.scrollTop = 0;
    if (location.hash !== '#' + id) history.replaceState(null, '', '#' + id);
    return true;
  }
  $$('[data-open-process]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (openProcess(btn.dataset.openProcess)) e.preventDefault();
    });
  });
  const checkHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (id) openProcess(id);
  };
  checkHash();
  window.addEventListener('hashchange', checkHash);

  /* Gallery filter + lightbox ------------------------------------------- */
  $$('[data-gallery]').forEach((gallery) => {
    const items = $$('.gallery-item', gallery);
    const chips = $$('[data-filter]', gallery);
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const f = chip.dataset.filter;
        chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        items.forEach((it) => { it.hidden = f !== 'all' && it.dataset.category !== f; });
      });
    });

    const box = $('[data-lightbox]', gallery);
    if (!box) return;
    const img = $('img', box);
    const cap = $('.lightbox__cap', box);
    items.forEach((it) => {
      it.addEventListener('click', () => {
        img.src = it.dataset.full;
        img.alt = it.dataset.title || '';
        cap.textContent = it.dataset.title || '';
        openDialog(box);
      });
    });
  });

  /* Garment catalog ------------------------------------------------------ */
  $$('[data-catalog]').forEach((cat) => {
    const cards = $$('.garment-card', cat);
    const chips = $$('[data-cat-filter]', cat);
    const search = $('[data-cat-search]', cat);
    const count = $('[data-cat-count]', cat);
    const empty = $('[data-cat-empty]', cat);
    let active = 'all';

    function apply() {
      const q = (search && search.value || '').trim().toLowerCase();
      let shown = 0;
      cards.forEach((card) => {
        const okCat = active === 'all' || card.dataset.category === active;
        const okQ = !q || card.dataset.search.includes(q);
        card.hidden = !(okCat && okQ);
        if (!card.hidden) shown++;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' style' : ' styles');
      if (empty) empty.hidden = shown !== 0;
    }
    chips.forEach((chip) => chip.addEventListener('click', () => {
      active = chip.dataset.catFilter;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      apply();
    }));
    if (search) search.addEventListener('input', apply);
    apply();

    // Swatches recolor the garment illustration
    cards.forEach((card) => {
      const label = $('.garment-card__color', card);
      const quote = $('[data-quote-link]', card);
      const photo = $('[data-garment-img]', card);
      $$('.swatch', card).forEach((sw) => {
        // Preload this color's photo on hover so the swap is instant
        if (photo && sw.dataset.img) sw.addEventListener('pointerenter', () => { new Image().src = sw.dataset.img; }, { once: true });
        sw.addEventListener('click', () => {
          $$('.swatch', card).forEach((s) => s.setAttribute('aria-pressed', String(s === sw)));
          card.style.setProperty('--garment', sw.dataset.hex);
          if (photo && sw.dataset.img) {
            photo.src = sw.dataset.img;
            photo.alt = photo.alt.replace(/ in .*$/, '') + ' in ' + sw.dataset.name;
          }
          if (label) label.textContent = sw.dataset.name;
          if (quote) {
            const url = new URL(quote.href, location.origin);
            url.searchParams.set('color', sw.dataset.name);
            quote.href = url.pathname + url.search;
          }
        });
      });
    });
  });

  /* Contact form prefill from catalog / service links ------------------- */
  const quoteForm = $('[data-quote-form]');
  if (quoteForm) {
    const params = new URLSearchParams(location.search);
    const garment = params.get('garment');
    const color = params.get('color');
    const method = params.get('method');
    const gField = $('[name="contact[Garment]"]', quoteForm);
    if (garment && gField) gField.value = garment + (color ? ' – ' + color : '');
    if (method) {
      $$('[name^="contact[Decoration"]', quoteForm).forEach((cb) => {
        if (cb.value.toLowerCase() === method.toLowerCase()) cb.checked = true;
      });
    }
    if (garment || method) {
      const card = $('.form-card');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* Product: variant picker + thumbnails + quantity --------------------- */
  $$('[data-product]').forEach((root) => {
    const json = $('script[data-variants]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const buyBtn = $('[data-buy]', root);
    const fmt = (cents) => (root.dataset.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));

    function selected() {
      return $$('.option-group', root).map((g) => {
        const c = $('input:checked', g);
        return c ? c.value : null;
      });
    }
    function update() {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) {
        buyBtn.disabled = true;
        buyBtn.textContent = buyBtn.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      buyBtn.disabled = !v.available;
      buyBtn.textContent = v.available ? buyBtn.dataset.add : buyBtn.dataset.soldout;
      if (v.featured_image) {
        const main = $('[data-main-img]', root);
        if (main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
    $$('.option-group input', root).forEach((i) => i.addEventListener('change', update));

    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      const main = $('[data-main-img]', root);
      main.src = t.dataset.thumb;
      main.removeAttribute('srcset');
      $$('[data-thumb]', root).forEach((x) => x.setAttribute('aria-current', String(x === t)));
    }));
  });

  $$('.qty').forEach((q) => {
    const input = $('input', q);
    $$('button', q).forEach((b) => b.addEventListener('click', () => {
      const step = Number(b.dataset.step);
      input.value = Math.max(Number(input.min || 0), (Number(input.value) || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
})();
